<template>
    <div>
        <div class="form-group">
            <label for="">Nutzung Kontokorrentrahmen Ø</label>
            <input type="number" class="form-control" min="0" max="getKonto" step="1000" v-model="credit">
        </div>

        <app-rangeSlider 
            :minVal="0" 
            :maxVal="getKonto" 
            :val="credit"
            :dynamic="dynamic"
            :step="1"
            >
            <template v-slot:minval>{{ minVal }} €</template>
            <template v-slot:maxval>{{ formatNumber(getKonto) }} €</template>
        </app-rangeSlider>

        <div class="form-group mt-2">
            <label for="">Liquiditätsprovision (in %)</label>
            <input class="form-control" type="number" min="0" step="0.1" v-model="liqProv">
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {numberMixin} from '../mixins/numberMixin'
import RangeSlider from "./RangeSlider";

export default {
    mixins: [numberMixin],
    data: function () {
        return {
            minVal: 0,
            dynamic: "Credit"
        }
    },
    components: {
        'app-rangeSlider': RangeSlider
    },
    computed: {
       ...mapGetters([
           'getCredit',
           'getKonto'
       ]),
       credit: {
           get() {
               return this.$store.getters.getCredit
           },
           set(input) {
               this.$store.commit('updateCredit', input)
           }
       },
       liqProv: {
            get() {
                return this.$store.getters.getLiqProv
            },
            set (value) {
                this.$store.commit('updateLiqProv', value)
            }
        }
    }
}
</script>